module.exports = __webpack_public_path__ + "static/media/expert-header.089cc4ba.png";